module.exports = __webpack_public_path__ + "img/documents.3b668432.svg";